import {addTeaDucksFormToDrawer} from './td-product.js';

function initializeCategory(root) {
  if (root.dataset.categoryReady) return;
  root.dataset.categoryReady = 'true';
  const dialog = root.querySelector('.td-quick-dialog');
  const form = dialog.querySelector('form');
  const formats = dialog.querySelector('[data-quick-formats]');
  const frequencies = dialog.querySelector('[data-quick-frequencies]');
  const submit = dialog.querySelector('[data-quick-submit]');
  const error = dialog.querySelector('[data-quick-error]');
  const variantSelect = dialog.querySelector('[data-quick-variant]');
  const subscriptionButton = dialog.querySelector('[data-quick-purchase="subscription"]');
  const onceButton = dialog.querySelector('[data-quick-purchase="once"]');
  const tick = () => dialog.querySelector('[data-quick-tick-template]').content.cloneNode(true);
  let product;
  let formatIndex = 0;
  let variantId;
  let purchase = 'subscription';
  let planId;
  let trigger;

  function variant() {
    return product.formats[formatIndex].variants.find(item => String(item.id) === String(variantId));
  }
  function defaultPlan(plans) {
    return plans.find(plan => plan.label === '1 month') || plans.find(plan => /month/i.test(plan.label)) || plans[0];
  }
  function setField(name, value) {
    let field = form.querySelector(`input[name="${name}"]`);
    if (value === null) { field?.remove(); return; }
    if (!field) { field = document.createElement('input'); field.type = 'hidden'; field.name = name; form.append(field); }
    field.value = String(value);
  }
  function render() {
    const selected = variant();
    if (!selected) return;
    const plans = selected.plans || [];
    const availablePlan = plans.find(plan => String(plan.id) === String(planId)) || defaultPlan(plans);
    planId = availablePlan?.id;
    if (!plans.length) purchase = 'once';
    if (selected.requiresPlan) purchase = 'subscription';
    formats.replaceChildren();
    product.formats.forEach((format, index) => {
      const button = document.createElement('button');
      button.type = 'button'; button.className = 'td-quick-option';
      button.setAttribute('aria-pressed', String(index === formatIndex));
      button.disabled = !format.variants.some(item => item.available);
      const copy = document.createElement('span'); copy.className = 'td-quick-option-copy';
      const title = document.createElement('span'); title.textContent = format.title;
      const detail = document.createElement('small'); detail.textContent = format.detail;
      copy.append(title, detail); button.append(copy, tick());
      button.addEventListener('click', () => {
        formatIndex = index; variantId = (format.variants.find(item => item.available) || format.variants[0]).id;
        render();
      });
      formats.append(button);
    });
    variantSelect.replaceChildren();
    product.formats[formatIndex].variants.forEach(item => {
      const option = document.createElement('option'); option.value = item.id; option.textContent = item.title;
      option.disabled = !item.available; option.selected = String(item.id) === String(variantId); variantSelect.append(option);
    });
    dialog.querySelector('[data-quick-variant-wrap]').hidden = product.formats[formatIndex].variants.length < 2;
    subscriptionButton.hidden = !plans.length;
    onceButton.hidden = !!selected.requiresPlan;
    subscriptionButton.setAttribute('aria-pressed', String(purchase === 'subscription'));
    onceButton.setAttribute('aria-pressed', String(purchase === 'once'));
    dialog.querySelector('[data-quick-once-price]').textContent = selected.money;
    dialog.querySelector('[data-quick-sub-price]').textContent = availablePlan?.money || '';
    const saving = availablePlan && selected.price ? Math.round((selected.price - availablePlan.price) * 100 / selected.price) : 0;
    dialog.querySelector('[data-quick-saving]').textContent = saving > 0 ? `Subscribe & save ${saving}%` : 'Subscribe';
    frequencies.replaceChildren();
    const order = {'1 week': 0, '2 weeks': 1, '1 month': 2};
    [...plans].sort((a, b) => (order[a.label] ?? 3) - (order[b.label] ?? 3)).forEach(plan => {
      const button = document.createElement('button'); button.type = 'button';
      button.setAttribute('aria-pressed', String(String(plan.id) === String(planId)));
      const label = document.createElement('span'); label.textContent = plan.label;
      button.append(label, tick());
      button.addEventListener('click', () => { planId = plan.id; render(); });
      frequencies.append(button);
    });
    dialog.querySelector('[data-quick-frequency-wrap]').hidden = purchase !== 'subscription';
    const terms = dialog.querySelector('[data-quick-terms]'); terms.replaceChildren();
    if (purchase === 'subscription' && availablePlan) {
      const renewal = document.createElement('p'); renewal.textContent = `${availablePlan.money} per delivery · Renews at your chosen frequency until cancelled.`;
      const flexibility = document.createElement('p'); flexibility.textContent = 'Swap your next tea, skip, pause or cancel in Account → Subscriptions.';
      terms.append(renewal, flexibility);
    } else terms.textContent = 'A single delivery, with no renewal.';
    setField('id', selected.id); setField('quantity', selected.min || 1);
    setField('selling_plan', purchase === 'subscription' ? planId : null);
    submit.name = 'add';
    submit.disabled = root.dataset.purchases === 'false' || form.getAttribute('aria-busy') === 'true' || !selected.available || (purchase === 'subscription' && !availablePlan);
    submit.textContent = selected.available ? `${purchase === 'subscription' ? 'Add subscription' : 'Add to bag'} · ${purchase === 'subscription' ? availablePlan?.money || selected.money : selected.money}` : 'Sold out';
  }

  root.querySelectorAll('[data-quick-add]').forEach(button => button.addEventListener('click', () => {
    trigger = button;
    try { product = JSON.parse(button.closest('.td-category-card').querySelector('[data-quick-product]').textContent); }
    catch { return; }
    product.formats = product.formats.filter(format => format.variants.length);
    if (!product.formats.length) return;
    const initialFormat = product.formats.findIndex(format => format.variants.some(item => String(item.id) === String(product.initialVariantId) && item.available));
    formatIndex = initialFormat >= 0 ? initialFormat : Math.max(0, product.formats.findIndex(format => format.variants.some(item => item.available)));
    variantId = (product.formats[formatIndex].variants.find(item => String(item.id) === String(product.initialVariantId) && item.available) || product.formats[formatIndex].variants.find(item => item.available) || product.formats[formatIndex].variants[0]).id;
    purchase = 'subscription'; planId = undefined; error.hidden = true;
    dialog.querySelector('[data-quick-title]').textContent = product.title;
    render(); dialog.showModal();
  }));
  variantSelect.addEventListener('change', () => { variantId = variantSelect.value; render(); });
  subscriptionButton.addEventListener('click', () => { purchase = 'subscription'; render(); });
  onceButton.addEventListener('click', () => { purchase = 'once'; render(); });
  dialog.querySelector('[data-quick-close]').addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', event => {
    const box = dialog.getBoundingClientRect();
    if (event.target === dialog && (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom)) dialog.close();
  });
  dialog.addEventListener('close', () => trigger?.focus({preventScroll:true}));
  form.addEventListener('submit', async event => {
    event.preventDefault();
    if (form.getAttribute('aria-busy') === 'true') return;
    await addTeaDucksFormToDrawer(form, root, {variant: variant(), planId: purchase === 'subscription' ? planId : '', beforeOpen: () => dialog.close()});
  });
  const links = [...root.querySelectorAll('[data-category-filter]')];
  const cards = [...root.querySelectorAll('.td-category-card')];
  const title = root.querySelector('[data-category-title]');
  const originalTitle = title.textContent;
  function filterCategory(category, updateUrl = false) {
    if (!links.some(link => link.dataset.categoryFilter === category)) category = 'all';
    let count = 0;
    cards.forEach(card => {
      const visible = category === 'all' || card.dataset.teaCategory === category;
      (card.closest('.td-category-card-wrapper') || card).hidden = !visible;
      if (visible) count++;
    });
    links.forEach(link => {
      if (link.dataset.categoryFilter === category) link.setAttribute('aria-current','page'); else link.removeAttribute('aria-current');
    });
    title.textContent = category === 'all' ? originalTitle : links.find(link => link.dataset.categoryFilter === category).textContent;
    root.querySelector('[data-category-count]').textContent = `${count} ${count === 1 ? 'tea' : 'teas'}`;
    if (updateUrl) { const url = new URL(location.href); if (category === 'all') url.searchParams.delete('td_category'); else url.searchParams.set('td_category',category); history.pushState(null,'',url); }
  }
  if (links.length) {
    filterCategory(new URL(location.href).searchParams.get('td_category') || 'all');
    links.forEach(link => link.addEventListener('click', event => { if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return; event.preventDefault(); filterCategory(link.dataset.categoryFilter,true); }));
    window.addEventListener('popstate', () => filterCategory(new URL(location.href).searchParams.get('td_category') || 'all'));
  }
}

document.querySelectorAll('[data-category-section]').forEach(initializeCategory);
document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-category-section]').forEach(initializeCategory));

